<div class="modal-fade-up relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog"
    aria-modal="true">

    <div
        class="absolute inset-0 z-10 overflow-hidden green-noise-bg bg-slate-50/95 dark:bg-[rgba(194,193,195,0.4)] flex items-center justify-center">

        <button type="button" (click)="closeModal()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>


        <div
            class="relative flex w-[90%] max-w-4xl max-h-[90vh] flex-col overflow-hidden gap-y-2 rounded-2xl border border-slate-200/80 bg-white/80 shadow-xl primary-card-container-no-padding dark:border-transparent dark:bg-transparent dark:shadow-none">
            <div aria-hidden="true"
                class="pointer-events-none absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>


            <div class="relative z-10 flex min-h-0 max-h-full flex-col overflow-hidden rounded-lg">
                <!-- Include this script tag or install `@tailwindplus/elements` via npm: -->
                <!-- <script src="https://cdn.jsdelivr.net/npm/@tailwindplus/elements@1" type="module"></script> -->
                <div class="shrink-0 px-4 py-5 sm:px-6 border-b border-gray-200 dark:border-white/10">
                    <div class="flex space-x-3 items-center">
                        <div
                            class="shrink-0 size-12 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-cyan-600 to-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8">
                                <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                                <path
                                    d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                                <path
                                    d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                                <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                            </svg>
                        </div>
                        <div class="min-w-0 flex-1">
                            <p class="text-lg font-semibold text-primary">
                                SHOUT Auto Pilot
                            </p>
                            <p class="text-sm text-secondary">
                                Hands-off hiring, chat, and review
                            </p>
                        </div>
                        <div class="relative z-20 flex shrink-0 self-center">

                        </div>
                    </div>
                </div>

                <div class="min-h-0 flex-1 overflow-y-auto px-4 py-4 scrollbar-transparent">
                    <div class="space-y-6">

                        <!-- What is Auto Pilot? -->
                        <div>
                            <div class="py-2 flex flex-row items-center justify-start gap-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-primary">
                                    <path
                                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                    <path d="M12 17h.01" />
                                </svg>

                                <h2 class="text-md font-semibold text-primary">What is Auto Pilot?</h2>
                            </div>

                            <div class="px-4 py-5 sm:p-6 card-container-pale">
                                <p class="text-sm text-primary">
                                    SHOUT's AI runs this brief end-to-end. The one setup step: add detailed
                                    moderation rules so content review isn't left to interpretation.
                                </p>
                            </div>
                        </div>
                        <!-- What is Auto Pilot? - END -->

                        <!-- How it works -->
                        <div>
                            <div class="py-2 flex flex-row items-center justify-start gap-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-primary">
                                    <path d="M16 7h6v6" />
                                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                                </svg>

                                <h2 class="text-md font-semibold text-primary">How it works</h2>
                            </div>

                            <div class="px-4 py-5 sm:p-6 card-container-pale">
                                <ul class="list-none space-y-3 p-0 text-sm text-primary">
                                    @for (item of howItWorks; track item.step) {
                                    <li class="flex flex-row items-center justify-start gap-x-2">
                                        <div
                                            class="size-6 shrink-0 rounded-full flex items-center justify-center bg-primary/10 outline-1 outline-primary text-accent">
                                            <p class="m-0 text-xs">{{ item.step }}</p>
                                        </div>
                                        <p class="m-0 min-w-0 text-primary">{{ item.description }}</p>
                                    </li>
                                    }
                                </ul>
                            </div>
                        </div>
                        <!-- How it works - END -->

                        <!-- Why it helps -->
                        <div>
                            <div class="py-2 flex flex-row items-center justify-start gap-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-primary">
                                    <path d="M13 5h8" />
                                    <path d="M13 12h8" />
                                    <path d="M13 19h8" />
                                    <path d="m3 17 2 2 4-4" />
                                    <path d="m3 7 2 2 4-4" />
                                </svg>

                                <h2 class="text-md font-semibold text-primary">Why it helps</h2>
                            </div>

                            <!-- <div class="px-4 py-5 sm:p-6"> -->
                            <div>
                                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    @for (item of features; track item.id) {
                                    <div class="flex flex-col gap-y-2 card-container-pale">
                                        @switch (item.id) {
                                        @case (1) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-accent">
                                            <path d="M12 8V4H8" />
                                            <rect width="16" height="12" x="4" y="8" rx="2" />
                                            <path d="M2 14h2" />
                                            <path d="M20 14h2" />
                                            <path d="M15 13v2" />
                                            <path d="M9 13v2" />
                                        </svg>
                                        }
                                        @case (2) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5 text-cyan-500">
                                            <path
                                                d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                                            <path d="M12 11h.01" />
                                            <path d="M16 11h.01" />
                                            <path d="M8 11h.01" />
                                        </svg>
                                        }
                                        @case (3) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-green-500">
                                            <path
                                                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                        </svg>
                                        }
                                        @case (4) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-yellow-500">
                                            <path
                                                d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
                                            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                                        </svg>
                                        }
                                        }
                                        <h3 class="text-sm font-semibold text-primary">{{ item.title }}</h3>
                                        <p class="text-sm text-secondary">{{ item.description }}</p>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <!-- Why it helps - END -->
                    </div>
                </div>

                <div
                    class="shrink-0 px-4 py-5 sm:px-6 w-full border-t border-gray-200 dark:border-white/10 flex flex-row items-center justify-center gap-x-4">
                    <button (click)="closeModal()" type="button"
                        class="rounded-full bg-white px-6 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20 hover:cursor-pointer">Maybe
                        Later</button>


                    <button (click)="toggleAutoPilot()"
                        *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]" type="button"
                        class="inline-flex items-center justify-center gap-x-1.5 rounded-full bg-gradient-to-br from-cyan-600 to-green-600 px-6 py-2 text-sm font-semibold text-white shadow-xs hover:from-cyan-700 hover:to-green-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary hover:cursor-pointer">
                        Enable Auto Pilot
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                            <path
                                d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                            <path
                                d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                        </svg>
                    </button>

                    <button (click)="openChoosePlan()" *notHasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]" type="button"
                        class="inline-flex items-center justify-center gap-x-1.5 rounded-full flashy-go-button px-6 hover:cursor-pointer">
                        Add AI Moderation to enable
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                            <path d="m16 12-4-4-4 4" />
                            <path d="M12 16V8" />
                            <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                            <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                            <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                            <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                        </svg>
                    </button>
                </div>
            </div>




            <div aria-hidden="true"
                class="pointer-events-none absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>

    </div>
</div>